import { jsx as _jsx } from "react/jsx-runtime";
import styles from './DealerLocatorSearchResultDistance.module.scss';
export const DealerLocatorSearchResultDistance = ({ children, }) => (_jsx("div", { className: `${styles['distance']} text-end cat-u-theme-typography-label-sm u-color--Black`, children: children }));
